import * as moment from 'moment';

export const daysData = [{
  caption: "Sun",
  order: 0
}, {
  caption: "Mon",
  order: 0
}, {
  caption: "Tue",
  order: 0
}, {
  caption: "Wed",
  order: 0
}, {
  caption: "Thu",
  order: 0
}, {
  caption: "Fri",
  order: 0
}, {
  caption: "Sat",
  order: 0
}];

export let timeOfDayData = [{
  caption: "Morning",
  icon: "pp-icon-morning",
  config: "PP_MorningTimeRange",
  startTime: moment('08:00', 'HH:mm').toDate(),
  endTime: moment('12:00', 'HH:mm').toDate()
}, {
  caption: "Afternoon",
  icon: "pp-icon-noon",
  config: "PP_AfternoonTimeRange",
  startTime: moment('12:00', 'HH:mm').toDate(),
  endTime: moment('17:00', 'HH:mm').toDate()
}, {
  caption: "Evening",
  icon: "pp-icon-evening",
  config: "PP_EveningTimeRange",
  startTime: moment('17:00', 'HH:mm').toDate(),
  endTime: moment('20:00', 'HH:mm').toDate()
}];

export interface IDateTimeFilterState {
  selectedDays: boolean[];
  selectedTimeOfDay: number;
  fromTime: Date;
  toTime: Date;
}

export interface IStackedViewFilterChip {
  item: any;
  type: FilterType;
  description: string;
}

export enum FilterType {
  DayFilter = 0,
  TimeRangeFilter = 1,
  LocationFilter = 2
}
